import React from 'react'
import { string, number, shape, arrayOf } from 'prop-types'

import { PieChart, Pie, Cell } from 'recharts'

const SimplePieChart = ({ data, width, height, colors }) => (
  <div className="pie-chart-wrapper">
    <PieChart width={width} height={height}>
      <Pie data={data} dataKey="value">
        {
          colors.length > 0 &&
          data.map((d, idx) => (
            <Cell fill={colors[idx % colors.length]} key={`cell-${d.name}-${idx}`}/>
          ))
        }
      </Pie>
    </PieChart>
  </div>
)

const dataItemProp = shape({
  name: string,
  value: number,
})

SimplePieChart.propTypes = {
  data: arrayOf(dataItemProp),
  width: number,
  height: number,
  colors: arrayOf(string),
}

export default SimplePieChart
